import { useEffect, useState } from 'react';
import RenderInputOption from './RenderInputOption';
import ShowOptions from '../function/ShowOptions';
import { useNavigation } from '../function/navigation';

function RenderGroup({
  keyName,
  subItems,
  inputs,
  setInputs,
  options,
  setOptions,
  result,
}) {
  const { nav, dispatch } = useNavigation();
  useEffect(() => {
    if (keyName === 'upper end' && subItems.includes(nav.focusedInput)) {
      dispatch({ type: 'spiralView', payload: 'upper-end' });
    } else if (keyName === 'lower end' && subItems.includes(nav.focusedInput)) {
      dispatch({ type: 'spiralView', payload: 'lower-end' });
    }
  }, [nav.focusedInput, dispatch, keyName, subItems]);

  const [isExpanded, setIsExpanded] = useState(true);

  if (
    !subItems ||
    subItems.every((item) => {
      const option = options.find((option) => option.field === item);
      return !ShowOptions(option, nav.showOptions);
    })
  )
    return;

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="group">
      <div className="info">
        <h3>{keyName}</h3>
        <div className="arrow-container">
          <div
            onClick={toggleExpand}
            className={`arrow ${isExpanded ? 'up' : ''}`}
          ></div>
        </div>
      </div>
      {isExpanded &&
        subItems.map((subField, index) => (
          <RenderInputOption
            key={`${keyName}-${subField}-${index}`}
            inputs={inputs}
            setInputs={setInputs}
            options={options}
            setOptions={setOptions}
            input_name={subField}
            result={result}
          />
        ))}
    </div>
  );
}

export default RenderGroup;
